import { MainContent } from "shared/styles";
import { EditBandInvitationForm } from "Bands/containers";
import { Card } from "shared/components";
import { copy } from "shared/assets";
import { User } from "shared/assets/icons";

export const EditInvitationPage = () => {
  return (
    <MainContent>
      <Card title={copy.members.editInvitation.title} icon={User}>
        <EditBandInvitationForm />
      </Card>
    </MainContent>
  );
};
